module.exports = __webpack_public_path__ + "static/media/flame.4b73aca5.svg";


//////////////////
// WEBPACK FOOTER
// ../images/flame.svg
// module id = 666
// module chunks = 0